import { PaginatedLoadingTable } from "@artprov/design-system"
import { memo } from "react";
import PropTypes from "prop-types";
import { getTableColumns, transformTableData } from "../functions/columnConfig.jsx";
import EmptyStateMessage from "../../../common/components/emptyStateMessage/EmptyStateMessage";
import { useComprasAuth } from "../../../common/hooks/useComprasAuth.js";

const InvoiceTable = memo(function InvoiceTable({ data, headers, onPageChange, loading, hasSearch, sortConfig, setSortConfig }) {
  const { userDetails } = useComprasAuth();
  const validateUsername = !!userDetails?.userPurchasePermissions;
  const transformedData = transformTableData(data, validateUsername);
  const columns = getTableColumns(validateUsername);
  const hasNoData = !loading && (!data || data.length === 0);

  return (
    <div className="w-full mt-4 pb-20">
      <PaginatedLoadingTable
        selectable={false}
        data={transformedData}
        headers={headers}
        columns={columns}
        className="w-full"
        onPageChange={onPageChange}
        sortable={true}
        sortConfig={sortConfig}
        setSortConfig={setSortConfig}
        uniqueKey="ID_COMPROBANTE"
        loadingIcon="progress_activity"
        loadingText="Solicitud en proceso"
        loadingIconVariant="primary"
        textVariant="subtitle1"
        textClassName="text-primary-10"
        isLoading={loading}
      />
      {hasNoData && (hasSearch
        ? <EmptyStateMessage />
        : <EmptyStateMessage title="Sin solicitudes" description="Actualmente, no tenés solicitudes que requieran tu aprobación. Volvé a revisar más tarde." />
      )}
    </div>
  )
});

InvoiceTable.propTypes = {
  data: PropTypes.array.isRequired,
  headers: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hasSearch: PropTypes.bool,
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }),
  setSortConfig: PropTypes.func,
}

export default InvoiceTable;
